export default {
    path: "/",
    name: "Accounting",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      {
        path: "/accounting_rules",
        name: "Accounting Rules",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "",
            component: () => import("@/views/accounting/accounting_rules/index.vue"),
          },
          {
            path: "create_rule",
            name: "Create Accounting Rule",
            component: () => import("@/views/accounting/accounting_rules/create_rule.vue"),
          },
          {
            path: "view_rule/:id",
            name: "View Accounting Rule",
            component: () => import("@/views/accounting/accounting_rules/view_rule.vue"),
          },
          {
            path: "edit_rule/:id",
            name: "Edit Accounting Rule",
            component: () => import("@/views/accounting/accounting_rules/edit_rule.vue"),
          },
        ],
      },
      {
        path: "/closing_entries",
        name: "Closing Entries",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "",
            component: () => import("@/views/accounting/closing_entries/index.vue"),
          },
          {
            path: "create_closure",
            name: "Create Closure",
            component: () => import("@/views/accounting/closing_entries/create_closure.vue"),
          },
          {
            path: "view_closure/:id",
            name: "View Closure",
            component: () => import("@/views/accounting/closing_entries/view_closure.vue"),
          },
          {
            path: "edit_closure/:id",
            name: "Edit Closure",
            component: () => import("@/views/accounting/closing_entries/edit_closure.vue"),
          },
        ],
      },
      {
        path: "/frequent_postings",
        name: "Frequent Postings",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "",
            component: () => import("@/views/accounting/frequent_postings/index.vue"),
          },
        ],
      },
      {
        path: "/add_journal_entries",
        name: "Add Journal Entries",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "",
            component: () => import("@/views/accounting/add_journal_entries/index.vue"),
          },
        ],
      },
      {
        path: "/financial_activity_mappings",
        name: "Financial Activity Mappings",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "",
            component: () => import("@/views/accounting/financial_activity_mappings/index.vue"),
          },
          {
            path: "create_mapping",
            name: "Add Mapping",
            component: () => import("@/views/accounting/financial_activity_mappings/create_mapping.vue"),
          },
          {
            path: "view_mapping/:id",
            name: "View Mapping",
            component: () => import("@/views/accounting/financial_activity_mappings/view_mapping.vue"),
          },
          {
            path: "edit_mapping/:id",
            name: "Edit Mapping",
            component: () => import("@/views/accounting/financial_activity_mappings/edit_mapping.vue"),
          },
        ],
      },
      {
        path: "/search_journal_entries",
        name: "Search Journal Entries",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "",
            component: () => import("@/views/accounting/search_journal_entries/index.vue"),
          },
          {
            path: "view_transaction/:id",
            name: "View Transaction",
            component: () => import("@/views/accounting/search_journal_entries/view_transaction.vue"),
          },
        ],
      },
      {
        path: "/migrate_opening_balances",
        name: "Migrate Opening Balances",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "",
            component: () => import("@/views/accounting/migrate_opening_balances/index.vue"),
          },
        ],
      },
      {
        path: "/chart_of_accounts",
        name: "Chart Of Accounts",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "",
            component: () => import("@/views/accounting/chart_of_accounts/index.vue"),
          },
          {
            path: "create_account",
            name: "Create Account",
            component: () => import("@/views/accounting/chart_of_accounts/create_account.vue"),
          },
          {
            path: "view_account/:id",
            name: "View Account",
            component: () => import("@/views/accounting/chart_of_accounts/view_account.vue"),
          },
          {
            path: "edit_account/:id",
            name: "Edit Account",
            component: () => import("@/views/accounting/chart_of_accounts/edit_account.vue"),
          },
        ],
      },
    ],
  };
  